import actionTypes from './actionTypes';

const initialState = {
  data: [],
  message: null,
  warning: null,
  loading: false,
  loaded: false
};

export default function information(state = initialState, action) {
  switch (action.type) {
    case actionTypes.INFO_LOAD: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case actionTypes.INFO_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        data: payload.data,
        message: payload.message,
        warning: payload.warning,
        loaded: true
      };
    }

    case actionTypes.INFO_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    default:
      return state;
  }
}
